// Registrar queues: exception requests and graduation applications
export const FETCH_EXCEPTION_QUEUE = 'DP_FETCH_EXCEPTION_QUEUE';
export const FETCH_EXCEPTION_QUEUE_SUCCESS = 'DP_FETCH_EXCEPTION_QUEUE_SUCCESS';
export const FETCH_EXCEPTION_QUEUE_ERROR = 'DP_FETCH_EXCEPTION_QUEUE_ERROR';
export const FETCH_GRADUATION_QUEUE = 'DP_FETCH_GRADUATION_QUEUE';
export const FETCH_GRADUATION_QUEUE_SUCCESS = 'DP_FETCH_GRADUATION_QUEUE_SUCCESS';
export const FETCH_GRADUATION_QUEUE_ERROR = 'DP_FETCH_GRADUATION_QUEUE_ERROR';
export const REVIEW_ACTION = 'DP_REVIEW_ACTION';
export const REVIEW_ACTION_DONE = 'DP_REVIEW_ACTION_DONE';
